module.exports = __webpack_public_path__ + "static/logo00-42459a82ac36de0bdfdbeb2727119b33.png";